import React from 'react'
import PropTypes from 'prop-types'

import DatePicker from 'react-datepicker'
import moment from 'moment'
import { Form, Modal } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './CreateReservationModalContainer'
import Enhancer from './CreateReservationModalEnhancer'

import Button from 'Components/StandardButton'
import ErrorMessage from 'Components/ErrorMessage'
import FormInputDropdownAddition from 'Components/FormInputDropdownAddition'

import icons from 'Global/icons'
import { getReservedDates, getLastAllowedReserveDate, getFirstAllowedDate } from 'Global/Helpers/reservationHelpers'

import * as styles from './styles'

import 'react-datepicker/dist/react-datepicker.css'

const CreateReservationModal = props => {
  const {
    close,
    dateFrom,
    dateTo,
    hasError,
    errors,
    event,
    eventOptions,
    handleEventChanged,
    handleEventItemAdded,
    handleEventReset,
    handleFromPicked,
    handleReasonChanged,
    handleSubmit,
    handleToPicked,
    isPending,
    reason,
    reservations,
  } = props

  const reservedDates = getReservedDates(reservations)

  return (
    <Modal onClose={close} open={true}>
      <Modal.Header>Reserve Rug</Modal.Header>

      <Modal.Content>
        {hasError && <ErrorMessage message="This wasn't supposed to happen. Please try again." />}

        <Form onSubmit={handleSubmit} size="tiny">
          <Form.Group>
            <Form.Group style={styles.innerFormGroup} widths="equal">
              <Form.Field error={errors.dates}>
                <label>From</label>

                <DatePicker
                  dateFormat="DD.MM.YYYY"
                  excludeDates={reservedDates}
                  minDate={moment(getFirstAllowedDate(reservations))}
                  name="dateFrom"
                  onChange={handleFromPicked}
                  placeholderText="From"
                  selected={dateFrom}
                />
              </Form.Field>

              <Form.Field error={errors.dates}>
                <label>To</label>

                <DatePicker
                  dateFormat="DD.MM.YYYY"
                  excludeDates={reservedDates}
                  maxDate={moment(getLastAllowedReserveDate(dateFrom, reservations))}
                  minDate={moment(dateFrom)}
                  name="dateTo"
                  onChange={handleToPicked}
                  placeholderText="To"
                  selected={dateTo}
                />
              </Form.Field>

              <FormInputDropdownAddition
                error={errors.event}
                name="event"
                onAddItem={handleEventItemAdded}
                onChange={handleEventChanged}
                options={eventOptions}
                pending={isPending}
                reset={handleEventReset}
                resetVisible={!!event}
                text={'Event'}
                value={event}
              />
            </Form.Group>
          </Form.Group>
          <Form.Field>
            <Form.TextArea
              error={errors.reason}
              label="Reason"
              name="reason"
              onChange={handleReasonChanged}
              placeholder="Reason"
              rows={2}
              style={styles.inputReason}
              type="text"
              value={reason}
            />
          </Form.Field>

          <span>Specify at least an event or a reason. You can add events that don't exist yet.</span>

          <div style={styles.button}>
            <Button color="black" content="Reserve" disabled={isPending} error={hasError} icon={icons['reservation']} pending={isPending} />
          </div>
        </Form>
      </Modal.Content>

      <Modal.Actions>
        <Button content="Close" icon={icons['close']} onClick={close} />
      </Modal.Actions>
    </Modal>
  )
}

CreateReservationModal.propTypes = {
  close: PropTypes.func.isRequired,
  dateFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  dateTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  errors: PropTypes.object.isRequired,
  event: PropTypes.string.isRequired,
  eventOptions: PropTypes.array.isRequired,
  handleEventChanged: PropTypes.func.isRequired,
  handleEventItemAdded: PropTypes.func.isRequired,
  handleEventReset: PropTypes.func.isRequired,
  handleFromPicked: PropTypes.func.isRequired,
  handleReasonChanged: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleToPicked: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  reason: PropTypes.string.isRequired,
  reservations: PropTypes.array.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(CreateReservationModal)
